<template>
  <div class="warning-list">
    <div v-for="item in warnings" :key="item.id" class="warning-row">
      <span>{{ item.town }}</span>
      <i>|</i>
      <span>{{ item.crop }}</span>
      <i>|</i>
      <span>{{ item.status }}</span>
      <i>|</i>
      <span>{{ item.yield }}</span>
      <i>|</i>
      <span>{{ item.risk }}</span>
    </div>
  </div>
</template>

<script setup>
const warnings = [
  {
    id: 1,
    town: "崇礼乡",
    crop: "红薯",
    status: "长势偏弱",
    yield: "预估亩产5200斤，同比-12%",
    risk: "干旱影响块茎膨大",
  },
  {
    id: 2,
    town: "邵店乡",
    crop: "红薯",
    status: "长势偏弱",
    yield: "预估亩产5200斤",
    risk: "3200斤、4500斤、2800斤",
  },
  {
    id: 3,
    town: "崇礼乡",
    crop: "红薯",
    status: "长势偏弱",
    yield: "预估亩产5200斤",
    risk: "同比-12%，干旱影响块茎膨大",
  },
  {
    id: 4,
    town: "邵店乡",
    crop: "红薯",
    status: "长势偏弱",
    yield: "预估亩产5200斤",
    risk: "3200斤、4500斤、2800斤",
  },
];
</script>

<style lang="less" scoped>
.warning-list {
  height: 330px;
  min-height: 0;
  display: grid;
  grid-template-rows: repeat(4, 1fr);
  gap: 14px;
  padding: 8px 0 0 10px;
  box-sizing: border-box;
}

.warning-row {
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 0 28px;
  color: #f2fbff;
  font-size: 24px;
  font-weight: 700;
  text-align: left;
  background: linear-gradient(90deg, rgba(8, 91, 108, 0.86), rgba(5, 66, 82, 0.66));
  box-shadow: inset 0 0 24px rgba(33, 216, 229, 0.08);

  span {
    white-space: nowrap;
  }

  i {
    margin: 0 12px;
    color: rgba(208, 247, 255, 0.78);
    font-style: normal;
  }
}
</style>
